import { useNavigate } from "@solidjs/router";
import MoviesPanel from "./MoviesPanel";

// Route wrapper for /movies — kept so anything that navigates here
// directly keeps working. The actual UI lives in MoviesPanel so it can
// also be shown inline (see Home.tsx, where selecting "Movies" in the
// header shows this without navigating away and losing the header row).
const Movies = () => {
  const navigate = useNavigate();

  return <MoviesPanel onEscape={() => navigate("/home")} />;
};

export default Movies;
